import * as React from 'react';

import { BaggageType } from '@websky/graphql';
import { EngineRenderers } from '@websky/core/src/renderProps';
import BaggageIconBase from '@websky/core/src/Baggage/Baggage/components/BaggageIcon/BaggageIcon';
import { BaggageSize } from '@websky/core/src/Baggage/Baggage/types';

import { SmallCarryOnIcon } from '../Icons';

const icons = new Map<BaggageType, Map<BaggageSize, React.ReactNode>>([
	[
		BaggageType.CarryOn,
		new Map([
			[BaggageSize.small, SmallCarryOnIcon],
			[BaggageSize.large, SmallCarryOnIcon]
		])
	]
]);

const BaggageIcon: EngineRenderers['BaggageIcon'] = props => {
	return <BaggageIconBase {...props} iconsMap={icons} />;
};

export default BaggageIcon;
